import { Component } from "react"
import SyncLoader from "react-spinners/SyncLoader"
import "./ValuationLoader.css"

const LOADING_MESSAGES = [
    "Analysing comparable sales",
    "Crunching the numbers",
    "Scanning the neighbourhood",
    "Cross-referencing sale prices",
    "Evaluating market trends",
    "Factoring in location data",
    "Reviewing recent transactions",
    "Calibrating price model",
    "Assessing local demand",
    "Computing valuation range",
    "Weighing property features",
    "Mapping nearby sold homes",
]

interface ValuationLoaderState {
    messageIndex: number
}

class ValuationLoader extends Component<{}, ValuationLoaderState> {
    private interval: NodeJS.Timeout | null = null

    constructor(props: {}) {
        super(props)
        this.state = {
            messageIndex: Math.floor(Math.random() * LOADING_MESSAGES.length),
        }
    }

    componentDidMount() {
        this.interval = setInterval(() => {
            this.setState((prev) => ({
                messageIndex: (prev.messageIndex + 1) % LOADING_MESSAGES.length,
            }))
        }, 2200)
    }

    componentWillUnmount() {
        if (this.interval) clearInterval(this.interval)
    }

    render() {
        return (
            <div className="valuation-loader">
                <div className="valuation-loader-content">
                    <SyncLoader size="10" color="#5cd5eb" />
                    <p className="valuation-loader-message" key={this.state.messageIndex}>
                        {LOADING_MESSAGES[this.state.messageIndex]}
                    </p>
                </div>
            </div>
        )
    }
}

export default ValuationLoader
